import { createFileRoute } from '@tanstack/react-router';
import api from '@/api';
import { TopicContent } from '@/courses/topic/TopicContent';
import { PreviewLayout } from '@/preview/PreviewLayout';

export const Route = createFileRoute('/preview/topic/$topicId')({
  component: PreviewTopic,
});

function PreviewTopic() {
  const topicId = Number(Route.useParams().topicId);
  const topic = api.previewTopic.useQuery(
    { path: { topic_id: topicId } },
    { retry: false },
  );
  return (
    <PreviewLayout current={{ topicId }}>
      {({ course, lessons }) => {
        if (!topic.data) return null;
        const lessonIndex = lessons.findIndex(
          (l) => l.id === topic.data.lesson_id,
        );
        const lesson = lessons[lessonIndex];
        // The student topic page, fed the draft; `isStudent` false is its existing
        // read-only preview mode, with no progress, completion or submit.
        return (
          <TopicContent
            courseTitle={course.title}
            courseSlug={course.slug}
            lessonTitle={lesson?.title ?? ''}
            lessonSlug={lesson?.slug ?? ''}
            topicTitle={topic.data.title}
            topicSlug={topic.data.slug}
            htmlContent={topic.data.content}
            lessonNumber={lessonIndex + 1}
            topicNumber={topic.data.index + 1}
            thoughtQuestions={topic.data.questions}
            isStudent={false}
            showsStatus={false}
            breadcrumbs={[
              { label: course.title, to: '/preview/' },
              { label: lesson?.title ?? '', to: '/preview/' },
              {
                label: topic.data.title,
                to: '/preview/topic/$topicId/',
                params: { topicId: String(topicId) },
              },
            ]}
          />
        );
      }}
    </PreviewLayout>
  );
}
